import React, { useState, useEffect } from 'react';
import Select from 'react-select';

function LetreroBrechas(props) {

    const desagregaciones = props.ejes.map((eje, index) => {
        return { ...eje, value: eje.category, label: eje.category }
    });
    const [desagregacion, setDesagregacion] = useState(undefined);

    useEffect(() => {
        setDesagregacion(desagregaciones[0]);
    }, [props]);

    function mostrarRegion() {
        if (props.infoReg.tipo === "mun") {
            return <>en el municipio de <span className="letreroRegion">{props.infoReg.municipio}</span></>
        } else if (props.infoReg.tipo === "dept") {
            return <>en el departamento de <span className="letreroRegion">{props.infoReg.municipio}</span></>
        } else {
            return <>en  <span className="letreroRegion">Colombia</span></>
        }
    }

    if (desagregacion) {
        const customStyles = {
            control: base => ({
                ...base,
                border: 0,
                boxShadow: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
            }),
            menu: styles => ({
                ...styles,
                minWidth: '270px',
                fontWeight: 'normal',
            }),
            singleValue: styles => ({
                ...styles,
                color: desagregacion.color,
                //textDecoration: 'underline',
            }),
            valueContainer: styles => ({
                ...styles,
                padding: 0,
                paddingRight: '10px',
            }),
            input: styles => ({
                ...styles,
                margin: 0,
                padding: 0,
            }),
        };

        function articuloVariable() {
            let first = props.infoEje.vari.name[0].toLowerCase()
            if (first.localeCompare("i", 'es', { sensitivity: 'base' }) === 0) {
                return "El"
            }
            if (first.localeCompare("p") === 0) {
                return "El"
            }
            else {
                return "La"
            }
        }

        function maxItem() {
            if (desagregacion.value.localeCompare("Departamentos", 'es', { sensitivity: 'base' }) === 0) {
                return <>del departamento de <span className="letreroMaxMin">{desagregacion.maxName}</span></>
            }
            if (desagregacion.value.localeCompare("Municipios", 'es', { sensitivity: 'base' }) === 0) {
                return <>del municipio de <span className="letreroMaxMin">{desagregacion.maxName}</span></>
            }
            if (desagregacion.value.localeCompare("Regiones PDET", 'es', { sensitivity: 'base' }) === 0) {
                return <>de la region de <span className="letreroMaxMin">{desagregacion.maxName}</span></>
            }
            return <span className="letreroMaxMin">{desagregacion.maxName}</span>
        }

        function minItem() {
            if (desagregacion.value.localeCompare("Departamentos", 'es', { sensitivity: 'base' }) === 0) {
                return <>del departamento de <span className="letreroMaxMin">{desagregacion.minName}</span></>
            }
            if (desagregacion.value.localeCompare("Municipios", 'es', { sensitivity: 'base' }) === 0) {
                return <>del municipio de <span className="letreroMaxMin">{desagregacion.minName}</span></>
            }
            if (desagregacion.value.localeCompare("Regiones PDET", 'es', { sensitivity: 'base' }) === 0) {
                return <>de la region de <span className="letreroMaxMin">{desagregacion.minName}</span></>
            }
            return <span className="letreroMaxMin">{desagregacion.minName}</span>
        }

        return (
            <div className="cajaLetreroBrechas">
                <p>Crea tus propias historias:</p>
                <div className="block">
                    <h2 className="letreroBrechas" style={{ borderColor: desagregacion.color }}>
                        {articuloVariable()}  <span className="letreroVariable">{props.infoEje.vari.name}</span> para el <span className="letreroAnio">{props.infoEje.year}</span> desagregada por
                        &nbsp;<span style={{ display: "inline-block" }}>
                            {/* components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }} */}
                            <Select
                                bsPrefix="form-control-sm"
                                options={desagregaciones}
                                closeMenuOnSelect={true}
                                onChange={(desag) => { setDesagregacion(desag) }}
                                value={desagregacion}
                                styles={customStyles}
                            />
                        </span>
                        &nbsp;{mostrarRegion()} nos muestra que para la población {maxItem()} hay <span className="letreroComparador">{desagregacion.brechaRel} {desagregacion.minValue == 0 ? "" : "veces"} más {desagregacion.minValue == 0 ? "casos de" : ""}</span> <span className="letreroVariableComparador">{props.infoEje.vari.name}</span> que para la población {minItem()}.
                    </h2>
                </div>
            </div>
        );
    }


}

export default LetreroBrechas;